import { useLoadedData } from "../../toolympus/hooks/useLoadedData";
import { Secretary } from "../Public/useSecretaryRegistration";

export const useSecretaryProfile = () => useLoadedData<Secretary>("/api/secretary/my", {} as Secretary);
